import actionTypes from './action-types';
import socketService from '../services/socket.service';
import cryptoService from '../services/crypto.service';
import { fetchAccounts } from './accounts';
import * as $ from 'jquery';
import * as moment from 'moment';

export function receiveUser(user) {
  return {
    type: actionTypes.RECEIVE_USER,
    user,
    isPasswordSet: !!cryptoService.getHashedKey(),
    shouldPasswordBeSet: user && !user.passwordDisabled
  };
}

export function isLoggedIn() {
  return async (dispatch, getState) => {
    const user = await socketService.emit('me');
    if (
      user &&
      moment(user.createdAt)
        .add(1, 'minute')
        .isAfter(moment())
    ) {
      if ((global as any).gtag) {
        (global as any).gtag('event', 'conversion', {
          send_to: (global as any).adwordsConversionId
        });
      }
    }
    dispatch(receiveUser(user));
  };
}

export function logout() {
  return async (dispatch, getState) => {
    await $.post('/logout');
    cryptoService.reset();
    window.postMessage && window.postMessage('logout', '*');
    dispatch(receiveUser(null));
  };
}

export function setPassword({ password = '', error = null }) {
  return {
    type: actionTypes.SET_USER_PASSWORD,
    password,
    error
  };
}

async function setPrivateKeys(dispatch, { rsaKeys = null } = {}) {
  if (!rsaKeys || !rsaKeys.private) {
    const pair = cryptoService.createPair();
    const user = await socketService.emit('setRsaKeys', pair);
    dispatch(receiveUser(user));
    rsaKeys = pair;
  }
  cryptoService.setPrivateRsaKey(rsaKeys.private);
  cryptoService.setPublicRsaKey(rsaKeys.public);
}

export function setSettings(settings = {}) {
  return async (dispatch, getState) => {
    const user = await socketService.emit('setSettings', settings);
    dispatch(receiveUser(user));
  };
}

export function checkPassword(password) {
  return async (dispatch, getState) => {
    try {
      cryptoService.setKey(password);
      const key = cryptoService.getHashedKey();
      await socketService.emit('checkPassword', key);
      cryptoService.addToStore();
      await setPrivateKeys(dispatch, getState().user);
      dispatch(setPassword({ password: key }));
      dispatch(fetchAccounts());
    } catch (error) {
      dispatch(setPassword({ error }));
    }
  };
}

export function disablePassword(password) {
  return async (dispatch, getState) => {
    const user = await socketService.emit('disablePassword');
    dispatch(receiveUser(user));
  };
}



// WEBPACK FOOTER //
// ./src/actions/user.ts